export default [
  {
    value: 'TO_PREV',
    label: '上移'
  },
  {
    value: 'TO_NEXT',
    label: '下移'
  }
]
